// extracted by mini-css-extract-plugin
export default {"container":"footer_container__WeoWP","copyright":"footer_copyright__mtAA6","redes":"footer_redes__rJ+OS"};